import React from "react";
import { Plus } from "lucide-react";

/**
 * État vide unique du Design System Pilotage :
 * [icône discrète] [titre] [description] [CTA optionnel]
 */
export default function EmptyState({ icon: Icon, title, description, actionLabel, onAction, testid = "empty-state" }) {
  return (
    <div className="py-10 sm:py-16 px-5 sm:px-6 text-center rounded-2xl border border-dashed border-slate-200 bg-slate-50/60" data-testid={testid}>
      {Icon && (
        <div className="mx-auto h-11 w-11 sm:h-12 sm:w-12 rounded-2xl bg-white border border-slate-200 flex items-center justify-center mb-3 sm:mb-4">
          <Icon className="h-5 w-5 text-slate-400" />
        </div>
      )}
      <h3 className="font-heading text-base font-semibold text-slate-900">{title}</h3>
      {description && <p className="text-sm text-slate-500 mt-1 max-w-sm mx-auto">{description}</p>}
      {onAction && (
        <button
          onClick={onAction}
          className="mt-4 sm:mt-5 inline-flex items-center justify-center gap-1.5 h-10 px-4 rounded-xl bg-violet-600 text-white text-xs font-bold hover:bg-violet-500 transition-colors"
          data-testid={`${testid}-action`}
        >
          <Plus className="h-4 w-4" strokeWidth={2.5} /> {actionLabel}
        </button>
      )}
    </div>
  );
}
